<template>
  <div class="body-container group-order-page">
    <div class="head-box">
      <div class="head-search-box">
        <div class="time-box" @click="$refs.datePanel.open()">
          <span>{{ startTime.replace(/-/g, '/') }} - {{ endTime.replace(/-/g, '/') }}</span>
          <i class="arr-icon"></i>
        </div>
        <img @click="goSearch" src="@static/images/search2.png" class="search-icon" />
        <!-- <searchInput ref="searchInput" :isOrder="activeIndex == 1"></searchInput> -->
      </div>
      <van-tabs v-model="activeaNav" @change="changeOneTab" class="list-tabs small oneTab">
        <van-tab title="团险新单" :name="1"></van-tab>
        <van-tab title="团财保全" :name="2"></van-tab>
      </van-tabs>
      <van-tabs v-model="activeIndex" @change="tabClick" class="list-tabs small twoTab" v-if="activeaNav == 1">
        <van-tab title="全部" :name="0"></van-tab>
        <van-tab title="未完成" :name="1"></van-tab>
        <van-tab title="已出单" :name="2"></van-tab>
        <van-tab title="已退款" :name="3"></van-tab>
      </van-tabs>
      <van-tabs v-model="activeIndex" @change="tabClick" class="list-tabs small twoTab" v-else-if="activeaNav == 2">
        <van-tab title="全部" :name="0"></van-tab>
        <van-tab title="已完成" :name="1"></van-tab>
        <van-tab title="未完成" :name="2"></van-tab>
      </van-tabs>
    </div>
    <ul class="child-type" v-if="activeIndex == 1 && (typeId || list.length) && activeaNav == 1">
      <li v-for="(item, i) in typeList1" :key="i" :class="{ 'active': typeId == item.id }" @click="clickTypeLevel2(item.id)">
        {{ item.name }}
      </li>
    </ul>
    <ul class="child-type" v-if="activeIndex == 2 && (typeId || list.length) && activeaNav == 1">
      <li v-for="(item, i) in typeList2" :key="i" :class="{ 'active': typeId == item.id }" @click="clickTypeLevel2(item.id)">
        {{ item.name }}
      </li>
    </ul>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <orderList ref="list" @setListParams="setListParams" @listCallback="listCallback" :policyType="activeaNav"> </orderList>
      <!-- 日期选择弹窗 -->
      <datePopup dateType="date" ref="datePanel" @submit="selectDate"></datePopup>
    </van-pull-refresh>
  </div>
</template>

<script>
import orderList from './components/list';
import datePopup from '@/components/tools/datePopup';
import { pageTools, common } from '@/api/mixins';
// import searchInput from "./components/searchInput";
import bottomNav from '@/components/bottomNav';
export default {
  name: 'order.groupOrder',
  mixins: [pageTools, common],
  components: { datePopup, orderList, bottomNav },
  data() {
    return {
      active: 0,
      typeId: '',
      typeList1: [
        { name: '全部', id: '' },
        { name: '未支付', id: '1' },
        { name: '已支付', id: '2' }
      ],
      typeList2: [
        { name: '全部', id: '' },
        { name: '保障中', id: '1' },
        { name: '已终止', id: '2' }
      ],
      type: '1',
      name: '', //投/被人姓名
      startTime: '',
      endTime: '',
      activeIndex: 0,
      activeaNav: 1,
      isLoading: false,
      list: []
    };
  },
  mounted() {
    if (!this.checkLogin()) {
      return;
    }
    if (sessionStorage.appGroupOrderTab) {
      this.activeIndex = sessionStorage.appGroupOrderTab * 1;
    }
    // 查询订单列表
    this.$refs.datePanel.init('date');
    this.$weixin.hideMenu();
  },
  methods: {
    onRefresh() {
      this.isLoading = false;
      this.$refs.list.searchAjax();
    },
    listCallback(res) {
      this.list = res.data;
    },
    //设置产品参数
    setListParams(params) {
      if (this.activeaNav == 1) {
        if (this.activeIndex) {
          params.firstStatusType = this.activeIndex;
        }
        if (this.typeId) {
          params.secondStatusType = this.typeId;
        }
      } else {
        if (this.activeIndex == 1) {
          params.statusList = '50';
        } else if (this.activeIndex == 2) {
          params.statusList = [20, 0, -99, 30, -15, 40, -20];
        }
      }

      params.insureTimeStart = this.startTime;
      params.insureTimeEnd = this.endTime;
      return params;
    },
    changeOneTab(val) {
      this.activeIndex = 0;
      this.selectDate(val, true);
    },
    // 选择时间、切换新单保全
    selectDate(date, type) {
      if (!type) {
        this.startTime = date[0];
        this.endTime = date[1];
      }
      this.$refs.list.list = [];
      // 初始化列表
      if (this.activeaNav == 1) {
        this.$refs.list.init('/api/grouporder/read/list');
      } else {
        this.$refs.list.init('/api/grouporder/page/endorsementList');
      }
    },
    goSearch() {
      sessionStorage.searchVal = '';
      const url = `/apps/groupOrder/search?activeaNav=${this.activeaNav}`;
      if (this.$config.isApp) {
        this.$app.openWeb(location.origin + url);
      } else {
        this.$router.push({
          path: url
        });
      }
    },
    // 列表跳转
    goPage(url, params, e) {
      if (e.target.className.indexOf('copy') != -1) {
        return;
      }
      this.$router.push({
        path: url,
        query: params
      });
    },
    tabClick() {
      sessionStorage.appGroupOrderTab = this.activeIndex;
      this.list = [];
      this.typeId = '';
      this.$refs.list.searchAjax();
    },
    clickTypeLevel2(id) {
      this.list = [];
      this.typeId = id;
      this.$refs.list.searchAjax();
    }
  }
};
</script>

<style lang="scss" scoped>
@import './list';
</style>
